export default __webpack_public_path__ + "static/chakra-24b528b09ef812e841275a9a67e197ce.png";